import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getVentilatorSelector } from '../selectors'
import { VentilatorConstants } from '../store/ventilator.constants'
import { IVentilatorState } from '../store/ventilator.types'

export function* setAction() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const ventilatorState: IVentilatorState = yield select(getVentilatorSelector)
  const { inputRows } = procedureState
  const { action } = ventilatorState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === VentilatorConstants.SET_ACTION) {
        //@ts-ignore
        input.props.savedValues = action
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setActionSaga() {
  yield takeLatest([VentilatorConstants.SET_ACTION], setAction)
}
